'use strict';

import * as Props from '../Props';

const angular = require('angular');

const RepeatingTableProperties = {
    Basic: {
        'ControlType': 'RepeatingTable',
        'Label': {
            name: 'label',
            selectedValue: 'Repeating Table',
            type: 'textbox',
            hidden: true
        },
        'Field Name': Props.getFieldName('Repeating_Table'),
        'Data Field Name': Props.getDataFieldName('Repeating_Table'),
        'Columns': {
            name: 'columns',
            selectedValue: 3,
            type: 'number',
            onChangeFunction: 'updateRepeatingTable',
            min: 1,
            max: 20
        },
        'Include_Header': {
            name: 'include.header',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'updateHeaderAndFooter'
        },
        'Include_Footer': {
            name: 'include.footer',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'updateHeaderAndFooter'
        },
        'Insert_Button_Text': {
            name: 'insert.button.text',
            selectedValue: 'Insert Row',
            type: 'textbox'
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'RemoveOptions': {
            type: 'button-group',
            members: {
                'Remove Width': {
                    type: 'button',
                    title: 'Remove Width',
                    selectedValue: '1',
                    icon: 'fa fa-eraser',
                    onClickFunction: 'removeWidth'
                }
            }
        },
        'Fit-to-Screen': {
            name: 'fit.to.screen',
            extraClass: 'fit-to-screen',
            selectedValue: false,
            type: 'checkbox',
            icon: 'fa fa-info'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Borders: {
        'border-style-group': {
            type: 'style-group',
            members: {
                'border-width': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 1,
                    min: '1',
                    max: '99',
                    default: 1,
                    onChangeFunction: 'updateStyle'
                },
                'border-color': {
                    type: 'color-picker',
                    title: 'border.color',
                    selectedValue: '#cccccc',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'Name': {
            selectedValue: 'Borders',
            hidden: true
        }
    },
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {}
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    InsertButtonStyle: angular.copy(Props.InsertButtonStyleObj),
    EvenOddRowStyle: {
        'style-group': {
            type: 'style-group',
            members: {
                'background-color-even': {
                    type: 'color-picker',
                    title: 'backgroundcoloreven',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle',
                    name: 'backgroundcoloreven'
                },
                'background-color-odd': {
                    type: 'color-picker',
                    title: 'backgroundcolorodd',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle',
                    name: 'backgroundcolorodd'
                },
            }
        },
        'Name': {
            selectedValue: 'row.style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        OnInsertRow: {
            name: 'OnInsertRow',
            type: 'event',
            selectedValue: '',
            xmlValue: '',
            systemFields: [],
            onClickFunction: 'openCodeEditorDialog'
        },
        OnDeleteRow: {
            name: 'OnDeleteRow',
            type: 'event',
            selectedValue: '',
            xmlValue: '',
            systemFields: [],
            onClickFunction: 'openCodeEditorDialog'
        }
    }
};

export default RepeatingTableProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Repeating_Table.ts